import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { ReviewService } from "src/app/review/review.service";
import { AccountService, AuthService, GridFilter, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { ReviewKpiItemBundle } from "src/app/review/kpi-review/kpi-review.component";
import { ReceiptPaymentModel } from "../../order/model/receiptpayment.model";
import { Subject } from "rxjs";
import { pairwise, takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { ReviewFilter } from "../../../review/models/review-filter";
import { ReviewHelper } from "../../../review/review-helper";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EnumModel } from "../../order/orderpage/item/deposit/deposit.component";
import { MealEnum, DeliveryEnum, ClearEnum } from "../../catalog/model/deposit.enum";
import { ReviewFilterItem } from "src/app/review/models/review-filter-item";
import { PaymentLinkState } from "../../order/model/invoice.model";

@Component({
  selector: "ngx-sales-review",
  templateUrl: "./sales-review.component.html",
  styleUrls: ["./sales-review.component.scss"],
  providers: [ReviewService],
})
export class SalesReviewComponent implements OnInit, OnDestroy {
  customDataList: any[] = [];
  hideChart: boolean;
  ngUnsubscribe = new Subject<void>();
  formGroup: UntypedFormGroup;
  activeTabTitle: string;
  unSortableFilterable: string[] = [];
  unSortableFilterableDeposit: string[] = [];
  unSortableFilterableScheduleList: string[] = [];
  c: string[] = [];
  BranchIds = undefined;
  ItemCategoryIds = undefined;
  SaleMethodIds = undefined;
  WaiterListIds = undefined;
  UserListIds = undefined;
  InvoiceStatusIds = undefined;
  DriverIds = undefined;
  SalePriceTypeIds = undefined;
  SalonIds = undefined;
  accountstatus = undefined;
  SMSType = undefined;
  PaymentState = undefined;
  PaymentMethod = undefined;
  Months = undefined;
  Delivery = undefined;
  Cook = undefined;
  ClearType = undefined;
  DeliveryType = undefined;
  MealTime = undefined;
  GetSaleMethodSummaryColumns: form_control[] = [];
  GetBranchSaleComparisonColumns: form_control[] = [];
  GetMmonthSummaryColumns: form_control[] = [];
  GetDaySummaryColumns: form_control[] = [];
  GetHourSummaryColumns: form_control[] = [];
  GetUserSummaryColumns: form_control[] = [];
  GetDriverSummaryColumns: form_control[] = [];
  GetWaiterSummaryColumns: form_control[] = [];
  GetItemCategorySummaryColumns: form_control[] = [];
  GetInvoiceSummaryColumns: form_control[] = [];
  GetInvoiceScheduleListColumns: form_control[] = [];
  GetSaleQuantitySummaryColumns: form_control[] = [];
  GetInvoiceItemSummaryColumns: form_control[] = [];
  GetUserSettlementSummaryColumns: form_control[] = [];
  GetDriverSettlementSummaryColumns: form_control[] = [];
  GetPaymentMethodSaleSummaryColumns: form_control[] = [];
  GetReceiptPaymentSummaryColumns: form_control[] = [];
  GetItemSummaryColumns: form_control[] = [];
  GetItemsNumberSummaryColumns: form_control[] = [];
  GetItemAdditiveSummaryColumns: form_control[] = [];
  GetItemDescriptionSummaryColumns: form_control[] = [];
  ReceiptPaymentColumns: form_control[] = [];
  invoiceItemSummaryColumns: form_control[] = [];
  depositSalesSummaryColumns: form_control[] = [];
  personnelServicesSummaryColumns: form_control[] = [];
  depositSummaryColumns: form_control[] = [];
  selected: string = "";
  UserSettlementReceipt: ReceiptPaymentModel[];
  DriverSettlementReceipt: ReceiptPaymentModel[];
  kpiBundles: ReviewKpiItemBundle[] = [
    {
      item1: { name: "Total", displayName: "ClientApp.FrontOffice.Review.SalesReview.CollectGoods" },
      item2: { name: "InvoiceCount", displayName: "ClientApp.FrontOffice.Review.SalesReview.Counter" },
      class: "kpi-colr1",
    },
    {
      item1: { name: "TotalDiscount", displayName: "ClientApp.FrontOffice.Review.SalesReview.Discount" },
      item2: { name: "TotalTip", displayName: "ClientApp.FrontOffice.Review.SalesReview.Reward" },
      class: "kpi-colr2",
    },
    {
      item1: { name: "TotalCourierShippingCost", displayName: "ClientApp.FrontOffice.Review.SalesReview.TotalCourierShippingCost" },
      item2: { name: "TotalShippingCost", displayName: "ClientApp.FrontOffice.Review.SalesReview.Rent" },
      class: "kpi-colr3",
    },
    {
      item1: { name: "TotalTax", displayName: "ClientApp.FrontOffice.Review.SalesReview.Tax" },
      item2: { name: "TotalService", displayName: "ClientApp.FrontOffice.Review.SalesReview.Service" },
      class: "kpi-colr4",
    },
    {
      item1: { name: "TotalPackingPrice", displayName: "ClientApp.FrontOffice.Review.SalesReview.PackingPrice" },
      item2: { name: "TotalRounding", displayName: "ClientApp.FrontOffice.Review.SalesReview.Round" },
      class: "kpi-colr5",
    },
    {
      item1: { name: "TotalDebit", displayName: "ClientApp.FrontOffice.Review.SalesReview.Debit" },
      item2: { name: "TotalCredit", displayName: "ClientApp.FrontOffice.Review.SalesReview.Credit" },
      class: "kpi-colr6",
    },
    {
      item1: { name: "Deposit", displayName: "ClientApp.FrontOffice.Review.SalesReview.Deposit" },
      item2: { name: "TakenDeposit", displayName: "ClientApp.FrontOffice.Review.SalesReview.TakenDeposit" },
      class: "kpi-colr1",
    },
    {
      item1: { name: "PayableTotal", displayName: "ClientApp.FrontOffice.Review.SalesReview.Payable" },
      item2: { name: "CashRemain", displayName: "ClientApp.FrontOffice.Review.SalesReview.Funds" },
      class: "kpi-colr2",
    },
  ];

  kpiBundlesDeposit: ReviewKpiItemBundle[] = [
    {
      item1: { name: "SalesAmount", displayName: "ClientApp.FrontOffice.Review.SalesReview.SalesAmount" },
      class: "kpi-colr1",
    },
    {
      item1: { name: "TakenDeposit", displayName: "ClientApp.FrontOffice.Review.SalesReview.TakenDeposit" },
      class: "kpi-colr2",
    },
    {
      item1: { name: "Remain", displayName: "ClientApp.FrontOffice.Review.SalesReview.Remain" },
      class: "kpi-colr3",
    },
    {
      item1: { name: "ServicesAmount", displayName: "ClientApp.FrontOffice.Review.SalesReview.PersonnelServices" },
      class: "kpi-colr6",
    },
    {
      item1: { name: "NumberOfCooks", displayName: "ClientApp.FrontOffice.Review.SalesReview.NumberOfCooks" },
      class: "kpi-colr4",
    },
    {
      item1: { name: "NumberOfPeople", displayName: "ClientApp.FrontOffice.Review.SalesReview.NumberOfPeople" },
      class: "kpi-colr5",
    },
  ];

  paymentStates = [
    { Id: PaymentLinkState.Nothing, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Nothing") },
    { Id: PaymentLinkState.SentLink, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.SentLink") },
    {
      Id: PaymentLinkState.OpenFactorLink,
      Selected: false,
      Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.OpenFactorLink"),
    },
    { Id: PaymentLinkState.Paying, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Paying") },
    { Id: PaymentLinkState.Paid, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Paid") },
    { Id: PaymentLinkState.FailPayment, Selected: false, Title: this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.FailPayment") },
  ];

  filterByDepositCreatedDate: boolean;

  public isMultiBranch =
    (this.authService.currentInformation().BranchingAdvancedEnabled ||
      this.authService.currentInformation().BranchingLightEnabled ||
      this.authService.currentInformation().RestaurantCallCenter) &&
    this.authService.currentBranch?.AccessToAllBranches;
  isDepositReview: boolean;
  MealTimeDataList: EnumModel[];
  DeliveryTypeDataList: EnumModel[];
  ClearTypeDataList: EnumModel[];
  hasUserSalesSummary: boolean;
  showAllDays = false;
  BranchSaleComparisonSummary: boolean = false;

  constructor(
    private service: ReviewService,
    private fb: UntypedFormBuilder,
    protected translate: TranslateService,
    protected authService: AuthService,
    private httpCommonService: HttpCommonService,
    _VoucherKindInfo: VoucherKindInfo,
    public accountService: AccountService
  ) {
    this.isDepositReview = _VoucherKindInfo.VoucherKindId === 2;
    this.MealTimeDataList = this.enumToEnumModelArray(MealEnum);
    this.DeliveryTypeDataList = this.enumToEnumModelArray(DeliveryEnum);
    this.ClearTypeDataList = this.enumToEnumModelArray(ClearEnum);
  }

  enumToArray(enumObj: any): any[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: Number(enumObj[key]), Title: key }));
  }

  enumToEnumModelArray(enumObj: any): EnumModel[] {
    return Object.keys(enumObj)
      .filter((key) => !isNaN(Number(enumObj[key])))
      .map((key) => ({ Id: enumObj[key], Title: key }));
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }

    this.formGroup = undefined;
    this.unSortableFilterable = undefined;
    this.unSortableFilterableScheduleList = undefined;
    this.c = undefined;
    this.BranchIds = undefined;
    this.ItemCategoryIds = undefined;
    this.SaleMethodIds = undefined;
    this.WaiterListIds = undefined;
    this.UserListIds = undefined;
    this.InvoiceStatusIds = undefined;
    this.DriverIds = undefined;
    this.SalePriceTypeIds = undefined;
    this.SalonIds = undefined;
    this.PaymentMethod = undefined;
    this.Months = undefined;
    this.GetSaleMethodSummaryColumns = undefined;
    this.GetMmonthSummaryColumns = undefined;
    this.GetDaySummaryColumns = undefined;
    this.GetHourSummaryColumns = undefined;
    this.GetUserSummaryColumns = undefined;
    this.GetDriverSummaryColumns = undefined;
    this.GetWaiterSummaryColumns = undefined;
    this.GetItemCategorySummaryColumns = undefined;
    this.GetInvoiceSummaryColumns = undefined;
    this.GetInvoiceScheduleListColumns = undefined;
    this.GetSaleQuantitySummaryColumns = undefined;
    this.GetInvoiceItemSummaryColumns = undefined;
    this.GetUserSettlementSummaryColumns = undefined;
    this.GetDriverSettlementSummaryColumns = undefined;
    this.GetPaymentMethodSaleSummaryColumns = undefined;
    this.GetReceiptPaymentSummaryColumns = undefined;
    this.GetItemSummaryColumns = undefined;
    this.GetItemsNumberSummaryColumns = undefined;
    this.GetItemAdditiveSummaryColumns = undefined;
    this.GetItemDescriptionSummaryColumns = undefined;
    this.ReceiptPaymentColumns = undefined;
    this.UserSettlementReceipt = undefined;
    this.DriverSettlementReceipt = undefined;
    this.kpiBundles = undefined;
  }

  ngOnInit(): void {
    this.unSortableFilterable = [
      ...this.unSortableFilterable,
      "Date",
      "CreationTime",
      "ClearedBy",
      "PaymentLinkState",
      "TerminalNumber",
      "RecieptTotal",
      "EditedBy",
      "SmsType",
      "OldRemain",
      "PersonnelTitle",
    ];
    this.service.startDate = new Date();
    this.service.endDate = new Date();
    this.service.ReportKey = "SalesReview";
    this.service.startDate$.next(this.service.startDate);
    this.service.endDate$.next(this.service.endDate);
    this.formGroup = this.fb.group({
      SaleMethodIds: this.SaleMethodIds,
      BranchIds: this.BranchIds,
      WaiterListIds: this.WaiterListIds,
      UserListIds: this.UserListIds,
      ItemCategoryIds: this.ItemCategoryIds,
      InvoiceStatusIds: this.InvoiceStatusIds,
      DriverIds: this.DriverIds,
      SalePriceTypeIds: this.SalePriceTypeIds,
      IncludeCancelled: true,
      SalonIds: this.SalonIds,
      accountstatus: this.accountstatus,
      SMSType: this.SMSType,
      PaymentState: this.PaymentState,
      PaymentMethod: this.PaymentMethod,
      Delivery: this.Delivery,
      Cook: this.Cook,
      ClearType: this.ClearType,
      DeliveryType: this.DeliveryType,
      MealTime: this.MealTime,
    });
    this.service.filterChangeSubject.pipe(pairwise(), takeUntil(this.ngUnsubscribe)).subscribe(([prev, next]) => {
      if (next && next.changedKeys.length > 0 && JSON.stringify(prev?.items) === JSON.stringify(next?.items)) {
        this.GetSaleChartData();
        this.GetMonthChart();
        this.GetUserSalesChart();
        this.ItemCategorySalesSummaryList();
        this.ItemSalesSummaryList();
      }
    });
    this.hasUserSalesSummaryList();
    this.hasBranchSaleComparisonSummaryList();
    this.hasViewReportAllDays();
  }
  hasBranchSaleComparisonSummaryList() {
    if (this.accountService.userHasPermission(`RestaurantSale:SaleReview`, "BranchSaleComparison")) {
      this.BranchSaleComparisonSummary = true;
    }
  }

  hasViewReportAllDays() {
    if (this.accountService.userHasPermission(`RestaurantSale:SaleReview`, "ViewReportAllDays")) {
      this.showAllDays = true;
    }
  }
  setColumns(activeTabTitle: string) {
    switch (activeTabTitle) {
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison"):
        if (this.GetBranchSaleComparisonColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetBranchSaleComparisonModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetBranchSaleComparisonColumns = data as form_control[];
                  this.GetBranchSaleComparisonColumns = this.GetBranchSaleComparisonColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Sale"):
        if (this.GetSaleMethodSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetSaleMethodSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetSaleMethodSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetSaleMethodSummaryColumns = this.GetSaleMethodSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.MonthSales"):
        if (this.GetMmonthSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetMonthSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetMmonthSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetMmonthSummaryColumns = this.GetMmonthSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetDaySummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetDaySaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetDaySummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetDaySummaryColumns = this.GetDaySummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetHourSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetHourSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetHourSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetHourSummaryColumns = this.GetHourSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Users"):
        if (this.GetUserSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetUserSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetUserSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetUserSummaryColumns = this.GetUserSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetDriverSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetDriverSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetDriverSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetDriverSummaryColumns = this.GetDriverSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetWaiterSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetWaiterSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetWaiterSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetWaiterSummaryColumns = this.GetWaiterSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.GoodsGroup"):
        if (this.GetItemCategorySummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetItemCategorySaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetItemCategorySummaryColumns = data as form_control[];
                  this.GetItemCategorySummaryColumns = this.GetItemCategorySummaryColumns.filter(
                    (x) =>
                      x.name !== "TotalNet" &&
                      x.name !== "TotalRounding" &&
                      x.name !== "TotalTip" &&
                      x.name !== "TotalShippingCost" &&
                      x.name !== "TotalDebit" &&
                      x.name !== "TotalCredit" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "Total" &&
                      x.name !== "BranchTitle"
                  ).sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Item"):
        if (this.GetItemSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetItemSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetItemSummaryColumns = data as form_control[];
                  this.GetItemSummaryColumns = this.GetItemSummaryColumns.filter(
                    (x) =>
                      x.name !== "Total" &&
                      x.name !== "TotalRounding" &&
                      x.name !== "TotalTip" &&
                      x.name !== "TotalShippingCost" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "TotalDebit" &&
                      x.name !== "TotalCredit" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "Total" &&
                      x.name !== "BranchTitle"
                  ).sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
        case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.ItemsNumber"):
        if (this.GetItemsNumberSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetItemsNumberSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetItemsNumberSummaryColumns = data as form_control[];
                  this.GetItemsNumberSummaryColumns = this.GetItemsNumberSummaryColumns.filter(
                    (x) =>
                      x.name !== "Total" &&
                      x.name !== "TotalRounding" &&
                      x.name !== "TotalTip" &&
                      x.name !== "TotalShippingCost" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "TotalDebit" &&
                      x.name !== "TotalCredit" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "Total" &&
                      x.name !== "BranchTitle"
                  ).sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.AdditiveAndDescription"):
        if (this.GetItemAdditiveSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetItemAdditiveSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetItemAdditiveSummaryColumns = data as form_control[];
                  this.GetItemAdditiveSummaryColumns = this.GetItemAdditiveSummaryColumns.filter(
                    (x) =>
                      x.name !== "Total" &&
                      x.name !== "TotalRounding" &&
                      x.name !== "TotalTip" &&
                      x.name !== "TotalShippingCost" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "TotalDebit" &&
                      x.name !== "TotalCredit" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "Total" &&
                      x.name !== "BranchTitle"
                  ).sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetItemDescriptionSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetItemDescriptionSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetItemDescriptionSummaryColumns = data as form_control[];
                  this.GetItemDescriptionSummaryColumns = this.GetItemDescriptionSummaryColumns.filter(
                    (x) =>
                      x.name !== "Total" &&
                      x.name !== "TotalRounding" &&
                      x.name !== "TotalTip" &&
                      x.name !== "TotalShippingCost" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "TotalDebit" &&
                      x.name !== "TotalCredit" &&
                      x.name !== "PayableTotal" &&
                      x.name !== "Total" &&
                      x.name !== "BranchTitle"
                  ).sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;

      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Factor"):
        if (this.GetInvoiceSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetInvoiceSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceSummaryColumns = data as form_control[];
                  this.GetInvoiceSummaryColumns = this.GetInvoiceSummaryColumns.filter((x) => x.name !== "InvoiceCount").sort(
                    (a, b) => a.order - b.order
                  );
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.SummarySaleQuantity"):
        if (this.GetSaleQuantitySummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetSaleQuantitySummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetSaleQuantitySummaryColumns = data as form_control[];
                  this.GetSaleQuantitySummaryColumns = this.GetSaleQuantitySummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetInvoiceItemSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetInvoiceItemSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceItemSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetInvoiceItemSummaryColumns = this.GetInvoiceItemSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.InvoiceSchedule"):
        if (this.GetInvoiceScheduleListColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetInvoiceScheduleListInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceScheduleListColumns = data as form_control[];
                  this.GetInvoiceScheduleListColumns = this.GetInvoiceScheduleListColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.FactorDetail"):
        if (this.GetInvoiceItemSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetInvoiceItemSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetInvoiceItemSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.GetInvoiceItemSummaryColumns = this.GetInvoiceItemSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.UserSettlementSummaryList"):
        if (this.GetUserSettlementSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetUserSettlementSummaryInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetUserSettlementSummaryColumns = data as form_control[];
                  this.GetUserSettlementSummaryColumns = this.GetUserSettlementSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.ReceiptPaymentColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetReceiptPaymentSettlementModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.ReceiptPaymentColumns = data as form_control[];
                  this.ReceiptPaymentColumns = this.ReceiptPaymentColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        if (this.GetDriverSettlementSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetDriverSettlementSummaryInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetDriverSettlementSummaryColumns = data as form_control[];
                  this.GetDriverSettlementSummaryColumns = this.GetDriverSettlementSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.PaymentMethodSaleSummaryList"):
        if (this.GetPaymentMethodSaleSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetPaymentMethodSaleSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetPaymentMethodSaleSummaryColumns = data as form_control[];
                  this.GetPaymentMethodSaleSummaryColumns = this.GetPaymentMethodSaleSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.ReceiptPaymentSummaryList"):
        if (this.GetReceiptPaymentSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetReceiptPaymentSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.GetReceiptPaymentSummaryColumns = data as form_control[];
                  this.GetReceiptPaymentSummaryColumns = this.GetReceiptPaymentSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.DepositSales"):
        if (this.depositSalesSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetDepositSalesSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.depositSalesSummaryColumns = data as form_control[];
                  this.depositSalesSummaryColumns = this.depositSalesSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.DepositDetail"):
        if (this.invoiceItemSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetInvoiceItemDepositSummaryModelInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.invoiceItemSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.invoiceItemSummaryColumns = this.invoiceItemSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.PersonnelServices"):
        if (this.personnelServicesSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetPersonnelServicesSummaryInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.personnelServicesSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.personnelServicesSummaryColumns = this.personnelServicesSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      case this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Deposit"):
        if (this.depositSummaryColumns?.length <= 0) {
          this.httpCommonService
            .get("SaleReview/GetDepositSummaryListInfo")
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (data) => {
                if (data) {
                  this.depositSummaryColumns = (data as form_control[]).filter((x) => x.name !== "BranchTitle");
                  this.depositSummaryColumns = this.depositSummaryColumns.sort((a, b) => a.order - b.order);
                }
              },
              (error) => console.log(error)
            );
        }
        break;
      default:
        break;
    }
  }
  selectTab($event) {
    this.setColumns($event.tabTitle);
    this.activeTabTitle = $event.tabTitle;
    if (this.activeTabTitle == this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.BranchSaleComparison")) {
      this.GetBranchSaleComparisonChartData();
    }
    if (this.activeTabTitle == this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Sale")) {
      this.GetSaleChartData();
    }
    if (this.activeTabTitle == this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.MonthSales")) {
      this.GetMonthChart();
    }
    if (this.activeTabTitle == this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.UserSales")) {
      this.GetUserSalesChart();
    }
    if (this.activeTabTitle == this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.GoodsGroup")) {
      this.ItemCategorySalesSummaryList();
    }
    if (this.activeTabTitle == this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Item")) {
      this.ItemSalesSummaryList();
    }
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  setSelectedFilter(filter: string) {
    if (this.selected === filter) this.selected = "";
    else this.selected = filter;
  }
  onRowSelected(row) {
    this.UserSettlementReceipt = row.length > 0 ? row[0].ReceiptPayments : null;
  }
  onSaleQuantityRowSelected(rows: any[]) {
    this.customDataList = rows.length > 0 ? rows[rows.length - 1]?.InvoiceItems : null;
  }
  onDriverRowSelected($event) {
    this.DriverSettlementReceipt = $event.length > 0 ? $event[0].ReceiptPayments : null;
  }
  chartData: any[] = [];
  isFinished: boolean;
  GetSaleChartData() {
    setTimeout(() => {
      const filter = this.FillFilters(this.service?.filterSubject?.getValue());
      this.httpCommonService
        .create("SaleReview/ReadSalesChart", filter)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any[]) => {
          this.chartData = data;
        });
    }, 100);
  }
  GetBranchSaleComparisonChartData() {
    setTimeout(() => {
      const filter = this.FillFilters(this.service?.filterSubject?.getValue());
      this.httpCommonService
        .create("SaleReview/ReadBranchSaleComparisonChart", filter)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any[]) => {
          this.chartData = data;
        });
    }, 100);
  }
  protected FillFilters(filters: ReviewFilter): GridFilter[] {
    var basefilters = ReviewHelper.buildQuery(filters);
    let _filters = [];
    if (this.authService.currentFiscalYear && this.authService.currentFiscalYear.Id)
      _filters.push(<GridFilter>{ Type: "F", Filed: "FiscalYearId", Value: this.authService.currentFiscalYear.Id, Operator: "eq" });
    basefilters.filters.forEach((x) => {
      if (x.Name === "StartDate") _filters.push(<GridFilter>{ Type: "F", Filed: "VoucherDate", Value: x.Value, Operator: "gte" });
      else if (x.Name === "EndDate") _filters.push(<GridFilter>{ Type: "F", Filed: "VoucherDate", Value: x.Value, Operator: "lte" });
      else if (x.Name === "StartNumber") _filters.push(<GridFilter>{ Type: "F", Filed: "VoucherNo", Value: x.Value, Operator: "gte" });
      else if (x.Name === "EndNumber") _filters.push(<GridFilter>{ Type: "F", Filed: "VoucherNo", Value: x.Value, Operator: "lte" });
      else if (x.Name.includes("Ids")) _filters.push(<GridFilter>{ Type: "F", Filed: x.Name, Value: x.Value, Operator: "contains" });
      else _filters.push(<GridFilter>{ Type: "F", Filed: x.Name, Value: x.Value, Operator: "eq" });
    });
    _filters.forEach((x) => {
      x.Take = 1000;
    });
    return _filters;
  }
  GetMonthChart() {
    if (this.activeTabTitle != this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.MonthSales")) {
      return;
    }
    const filter = this.FillFilters(this.service?.filterSubject?.getValue());
    this.httpCommonService
      .create("SaleReview/ReadMonthSalesChart", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any[]) => {
        this.chartData = data;
      });
  }
  GetUserSalesChart() {
    if (this.activeTabTitle != this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.UserSales")) {
      return;
    }
    const filter = this.FillFilters(this.service?.filterSubject?.getValue());
    this.httpCommonService
      .create("SaleReview/ReadUserSalesChart", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any[]) => {
        this.chartData = data;
      });
  }
  ItemCategorySalesSummaryList() {
    if (this.activeTabTitle != this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.GoodsGroup")) {
      return;
    }
    const filter = this.FillFilters(this.service?.filterSubject?.getValue());
    this.httpCommonService
      .create("SaleReview/ReadItemCategoryChart", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any[]) => {
        this.chartData = data;
      });
  }
  ItemSalesSummaryList() {
    if (this.activeTabTitle != this.translate.instant("ClientApp.FrontOffice.Review.SalesReview.Item")) {
      return;
    }
    const filter = this.FillFilters(this.service?.filterSubject?.getValue());
    this.httpCommonService
      .create("SaleReview/ReadItemChart", filter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: any[]) => {
        this.chartData = data;
      });
  }

  applyDepositDateFilter() {
    this.filterByDepositCreatedDate = !this.filterByDepositCreatedDate;
    if (this.filterByDepositCreatedDate) {
      const filters = [{ key: "DepositDateFilter", value: this.filterByDepositCreatedDate }];
      this.service.addFilter("DepositDateFilter", filters as ReviewFilterItem[]);
    } else {
      this.service.removeFilter("DepositDateFilter", "DepositDateFilter", [true], "array");
    }
  }

  hasUserSalesSummaryList() {
    if (this.accountService.userHasPermission(`RestaurantSale:SaleReview`, "UserSalesSummaryList")) {
      this.hasUserSalesSummary = true;
    }
  }
}
